/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Bundler, BundlerInterface } from "../Bundler";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "addressTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenID",
        type: "uint256",
      },
    ],
    name: "bundledAddresses",
    outputs: [
      {
        internalType: "address[]",
        name: "addresses",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenID",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "bundledIds",
    outputs: [
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenID",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "string",
        name: "uri",
        type: "string",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenID",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "tokenBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenID",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "unbundleAndBurn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenID",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenID",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class Bundler__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Bundler> {
    return super.deploy(overrides || {}) as Promise<Bundler>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): Bundler {
    return super.attach(address) as Bundler;
  }
  connect(signer: Signer): Bundler__factory {
    return super.connect(signer) as Bundler__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BundlerInterface {
    return new utils.Interface(_abi) as BundlerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Bundler {
    return new Contract(address, _abi, signerOrProvider) as Bundler;
  }
}
